import {Component, Input, OnInit} from '@angular/core';
import {fadeInAnimation} from '../../animations/fade-in.animation';
import {ICardIconText} from '../../interfaces/card';

@Component({
  selector: 'app-card-icon-text',
  templateUrl: './card-icon-text.component.html',
  styleUrls: ['./card-icon-text.component.scss'],
  animations: [fadeInAnimation]
})
export class CardIconTextComponent implements OnInit {

  @Input() active: boolean;
  @Input() value: ICardIconText = {
    label: '',
    img: ''
  };
  @Input() size: 'default' | 'small' = 'default';
  @Input() description: string;
  @Input() hasInformation: boolean;
  constructor() { }

  ngOnInit(): void {
  }

}
